import { gql } from '@apollo/client'

import { SIMPLE_USER_FRAGMENT } from '../../../common/graphql/fragments'

const ASSIGN_USER_TO_BRAND_CURATION_TASK_MUTATION = gql`
  mutation assignUserToBrandCurationTask(
    $id: ID!
    $userId: ID
    $actionType: UserAssignmentActionType!
  ) {
    assignUserToBrandCurationTask(
      id: $id
      userId: $userId
      actionType: $actionType
    ) {
      id
      taskStatus
      assignedCurator {
        ...SimpleUserFragment
      }

      assignedQa {
        ...SimpleUserFragment
      }

      assignedQc {
        ...SimpleUserFragment
      }
    }
  }
  ${SIMPLE_USER_FRAGMENT}
`

export default ASSIGN_USER_TO_BRAND_CURATION_TASK_MUTATION
